<template>
<div class="container">
  <div class="control pagination-centered">
    <img src="/static/logo.png" alt="logo"/>
    <article v-if="message" class="message is-warning">
      <div class="message-header">
        <p>Aviso</p>
        <button class="delete" @click="message = false"></button>
      </div>
      <div class="message-body">
        <p>Seu usuario não esta cadastrado neste evento.</p>
        <p>Favor entrar em contato com o nosso suporte através do email <a href="mailto:alunos@formuladelancamento.com.br">alunos@formuladelancamento.com.br</a> </p>
      </div>
    </article>
    <div class="control has-icon has-icon-left">
      <input type="text" class="input" v-model="doc" placeholder="Numero do documento" required>
      <span class="icon" style="color: #f0a939"><i class="fa fa-user"></i></span>
    </div>
    <div class="control">
      <button type="button" class="button" v-on:click="login()" :disabled="!doc">Entrar</button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      doc: '',
      message: null
    }
  },
  methods: {
    login() {
      let query = {
        "query": `{person_by_document(document: "${this.doc}"){
                    id
                    name
                    email
                    document
                    gender
                    observation
                    phone}}`
      }
      this.getEvent().then((response) => {
        this.$http.post(process.env.API_URL, query).then((response) => {
          if(!response.data.data.person_by_document){
            this.message = true
            this.$router.replace('/')
            return
          }
          localStorage.setItem("data", JSON.stringify(response.data.data.person_by_document))
          this.$router.replace('/index')
        },
        (response) => {
          if (response.status == 401) {
            window.localStorage.setItem('message', true)
            this.message = window.localStorage.getItem('message')
            this.$route.router.go({name: 'login'})
          }
        })
      })
    },
    getEvent(){
      let query = {
        "query": `{event(id: ${process.env.EVENT_ID}){
            id
            name
            description
            address
            quantity
            start_date
            end_date
            start_hour
            end_hour
            client_app
          }
        }`
      }

      return this.$http.post(process.env.API_URL, query).then((response) => {
        localStorage.setItem("event", JSON.stringify(response.body.data.event))
      })
    }
  }
}
</script>

<style scoped>
/* 363b41 */
.message{
  width: 314px;
}
.message.is-warning .message-header{
  background-color: #f0ad4e;
}
.button {
  width: 100%;
  height: 42px;
  border-radius: 0px;
  font-family: 'Open Sans', Arial, sans-serif;
  font-size: 18px;
  color: #FFF;
  background-color: #f0ad4e;
  border-color: #eea236;
}

button:hover{
  background-color: #eea236;
  color: white;
}

.btn-warning.btn-outline {
  color: #f0ad4e;
}

.pagination-centered {
  text-align: center;
}

.alert-danger{
  color: #a94442;
  background-color: #f2dede;
  border-color: #ebccd1;
}

input[type="text"] {
  background-color: #3b4148;
  color: #FFF;
  border: none;
  font-family: 'Open Sans', Arial, sans-serif;
  font-size: 18px;
  border-radius: 0;
}

input[type="text"]:focus,
input[type="text"]:active {
  border: none !important;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  box-shadow: none !important;
}

.container {
  width: 314px;
  left: 50%;
  position: fixed;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// Login.vue?970624e4